export interface MakeItem {
  make_id: string;
  make_name: string;
  manufacturer_id: string;
  manufacturer_name: string;
}

export const getMakeDisplayName = (make: MakeItem): string =>
  `${make.make_name} (${make.manufacturer_name})`;

export const filterMakesBySearch = (
  makes: MakeItem[],
  searchTerm: string,
): MakeItem[] => {
  const term = searchTerm.trim().toLowerCase();
  if (!term) {
    return makes;
  }

  return makes.filter(make => {
    const searchableValues = [make.make_name, make.manufacturer_name]
      .filter(Boolean)
      .map(value => String(value).toLowerCase());

    return searchableValues.some(value => value.includes(term));
  });
};
